/**
 * Shopify Checkout: append `payment=shop_pay` for Shop Pay (same path as standard checkout).
 */

const PAYMENT_QUERY_KEY = 'payment'
const SHOP_PAY_VALUE = 'shop_pay'

function appendPaymentQuery(url: string, value: string): string {
    const [base, queryString] = url.split('?')
    const params = new URLSearchParams(queryString || '')
    params.set(PAYMENT_QUERY_KEY, value)
    const qs = params.toString()
    return qs ? `${base}?${qs}` : base
}

export function appendShopPayPaymentQueryParam(url: string): string {
    return appendPaymentQuery(url, SHOP_PAY_VALUE)
}

/** When `useShopPay` is true, append Shop Pay query param to the checkout URL. */
export function applyShopPayToCheckoutUrl(
    href: string,
    useShopPay?: boolean | null,
): string {
    if (useShopPay) {
        return appendShopPayPaymentQueryParam(href)
    }
    return href
}
